import { i18n } from 'lib/i18n.js';
import { decode } from 'utils/general';
import { mapState, mapActions } from 'vuex';

function extractURLParams(url) {
  const queryString = url.split('?')[1] || '';
  const queryParams = queryString.split('&');
  const utmParams = {};
  queryParams.forEach(queryParam => {
    const [key, value] = queryParam.split('=');
    utmParams[key] = value;
  });

  return utmParams;
}

export default {
  name: 'geolocation',
  i18n,
  components: {
    modal: () => import('../modal/modal.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  data() {
    return {
      availableCountries: [],
      currentCountry: {
        name: 'United States',
        flag: '',
        iso_code: 'US',
      },
      originCountry: {
        name: 'United States',
        flag: '',
        iso_code: 'US',
      },
      currentLang: {
        name: 'English',
        iso_code: 'en',
      },
      originLang: {
        name: 'English',
        iso_code: 'en',
      },

      availableLanguages: [],
      isDropdownOpen: false,
      selectedCountry: null,
    };
  },
  mounted() {
    const countries = this.$refs.geo.dataset.countries;
    const languages = this.$refs.geo.dataset.languages;
    const countryObj = this.$el.dataset.currentCountry
      ? JSON.parse(decode(this.$el.dataset.currentCountry))
      : null;
    const defaultISOCode = this.$el.dataset.defaultIsoCode;
    if (countries) {
      this.availableCountries = JSON.parse(decode(countries));
      const selectedCountry = this.availableCountries.find(
        (country) => country.iso_code === Shopify.country,
      );
      // push UK manually when using metaobjects instead of markets
      if (!selectedCountry && countryObj && defaultISOCode === 'GB') {
        this.availableCountries.push(countryObj);
      }
      // sort countries alphabetically
      this.availableCountries.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        return 1;
      });
    }

    if (languages) {
      this.availableLanguages = JSON.parse(decode(languages));
    }
    this.originCountry = this.availableCountries.find(
      (country) => country.iso_code === Shopify.country,
    );
    this.originLang = this.availableLanguages.find(
      (language) => language.iso_code === Shopify.locale,
    );
    this.setUserCountry();
  },
  computed: {
    ...mapState('global', ['marketRecommendation']),
    change_country_text() { 
      return this.$t('geolocation.change_country').replace(
        '{country}',
        `${this.currentCountry.name}`,
      );;
    },
    title() {
      return this.$t('geolocation.title').replace(
        '{country}',
        `<b>${this.currentCountry.name}</b>`,
      );
    },
    currencyText() {
      return this.currentCountry?.currency
        ? this.$t('geolocation.currency').replace(
            '{currency}',
            this.currentCountry.currency,
          )
        : null;
    },
    shippingText() {
      return this.$t('geolocation.shipping_options').replace(
        '{country}',
        this.currentCountry.name,
      );
    },
    currentFlag() {
      if (!this.currentCountry?.flag) return '';

      return `--bg-image: url(${this.currentCountry.flag});`;
    },
  },
  methods: {
    ...mapActions('global', ['closeModal']),
    onCountryChange(country) {
      this.currentCountry = country;
    },
    onLangChange(lang) {
      this.currentLang = lang;
    },
    setUserCountry() {
      this.currentCountry = this.marketRecommendation?.country?.iso_code
        ? this.availableCountries.find(
            (country) =>
              country.iso_code.toLowerCase() ===
              this.marketRecommendation.country.iso_code.toLowerCase(),
          ) || this.originCountry
        : this.originCountry;
      this.currentLang =
        this.availableLanguages.find(
          (language) =>
            language.iso_code === this.marketRecommendation?.language,
        ) || this.originLang;
      this.selectedCountry = this.currentCountry.iso_code;
    },
    onSelectChange() {
      this.currentCountry = this.availableCountries.find(
        (country) => country.iso_code === this.selectedCountry,
      );
    },
    onStayClickHandle(){
      let expire = new Date(Date.now() + 300 * 864e5).toUTCString();
      document.cookie = `geo_selected=1; expires=${expire}; path=/`;
      this.closeModal();
    },
    onSaveSelection() {
      let expire = new Date(Date.now() + 300 * 864e5).toUTCString();
      document.cookie = `geo_selected=1; expires=${expire}; path=/`;

      const geoParam = {
        geo: 1
      };
      const params = new URLSearchParams(window.location.search);
      const utmParam = params.toString().includes('utm') ? extractURLParams(window.location.href) : {};

      const finalParams = {
        ...utmParam,
        ...geoParam
      };

      const geoString = `?${new URLSearchParams(finalParams).toString()}`;

      if (
        this.originCountry.iso_code != this.currentCountry.iso_code ||
        this.originLang.iso_code != this.currentLang.iso_code
      ) {
        const geoData = {
          country: { ...this.currentCountry },
        };
        let expire = new Date(Date.now() + 10 * 864e5).toUTCString();
        document.cookie = `geo_data=${JSON.stringify(
          geoData,
        )}; expires=${expire}; path=/`;

        if (this.currentCountry?.link !== '') {
          const MAIN_STORE_URL = 'https://fentybeauty.com'
          const { link, iso_code } = this.currentCountry;
          let marketLink = '';
          if (iso_code.toLowerCase() === 'us' || iso_code.toLowerCase() === 'gb') {
            marketLink = link
          } else {
            marketLink = `${MAIN_STORE_URL}/pages/redirect?market=en-${iso_code.toLowerCase()}${geoString}`
          }
          window.location = marketLink;
        } else {
          this.$refs.localization.submit();
        }
      } else {
        this.closeModal();
      }
    },
    toggleDropdown() {
      this.setUserCountry();
      this.isDropdownOpen = !this.isDropdownOpen;
    },
  },
};
